/**
 * 文档错误类型枚举
 * 用于区分不同的文档加载和处理错误
 */
export var DocumentErrorType;
(function (DocumentErrorType) {
    /** 文档不存在 */
    DocumentErrorType["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    /** 加载文档出错 */
    DocumentErrorType["DOCUMENT_LOAD_ERROR"] = "DOCUMENT_LOAD_ERROR";
    /** 存储服务错误 */
    DocumentErrorType["STORAGE_ERROR"] = "STORAGE_ERROR";
    /** 网络错误 */
    DocumentErrorType["NETWORK_ERROR"] = "NETWORK_ERROR";
    /** 输入参数无效 */
    DocumentErrorType["INVALID_INPUT"] = "INVALID_INPUT";
    /** 未知错误 */
    DocumentErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(DocumentErrorType || (DocumentErrorType = {}));
//# sourceMappingURL=reading-progress.js.map